import React, { useState } from 'react';
import { ArrowLeft, Download, Calendar, Upload, Eye } from 'lucide-react';
import CustomTab from '../../../components/common/CustomTab';
import CustomSearch from '../../../components/common/CustomSearch';
import CustomButton from '../../../components/common/CustomButton/CustomButton';
import CustomChip from '../../../components/common/CustomChip';
import CustomDataGrid from '../../../components/common/CustomDataGrid/CustomDataGrid';
import CustomDatePicker from '../../../components/common/CustomDatePicker/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import CustomDialog from "../../../components/common/CustomDialog/index"
import DragAndDrop from "../common/DragandDrop"
import { Formik, Form } from 'formik';


const initialAdvisorRows = [
  {
    id: 1,
    advisorName: 'Manohar',
    totalEarnings: 12,
    receivedEarnings: '₹50000',
    pendingEarnings: '₹50000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 2,
    advisorName: 'Vikas',
    totalEarnings: 23,
    receivedEarnings: '₹50000',
    pendingEarnings: '₹50000',
    lastPaymentDate: '12 Jan 2025'
  },
  {
    id: 3,
    advisorName: 'Sidharth Malviya',
    totalEarnings: 12,
    receivedEarnings: '₹50000',
    pendingEarnings: '₹50000',
    lastPaymentDate: '12 Jan 2025'
  },
  {
    id: 4,
    advisorName: 'Vikas',
    totalEarnings: 23,
    receivedEarnings: '₹50000',
    pendingEarnings: 'Approved',
    lastPaymentDate: '12 Jan 2025'
  },
];

const invoiceRows = [
  {
    id: 1,
    advisorName: 'Manohar',
    noOfLeads: 12,
    invoiceAmount: '₹50000',
    invoiceStatus: 'Pending',
  },
  {
    id: 2,
    advisorName: 'Vikas',
    noOfLeads: 23,
    invoiceAmount: '₹50000',
    invoiceStatus: 'Rejected',
  },
  {
    id: 3,
    advisorName: 'Sidharth Malviya',
    noOfLeads: 12,
    invoiceAmount: '₹50000',
    invoiceStatus: 'Approved',
  },
  {
    id: 4,
    advisorName: 'Vikas',
    noOfLeads: 23,
    invoiceAmount: '₹50000',
    invoiceStatus: 'Approved',
  },
];


const initialPaymentRows = [
  {
    id: 1,
    advisorName: 'Manohar',
    invoiceAmount: '₹2,20,000',
    paidAmount: '₹70,000',
    paymentStatus: 'Partially Paid',
    date: '15 March',
  },
  {
    id: 2,
    advisorName: 'Vikas',
    invoiceAmount: '₹2,20,000',
    paidAmount: 'NA',
    paymentStatus: 'Not-Paid',
    date: '15 March',
  },
  {
    id: 3,
    advisorName: 'Sidharth Malviya',
    invoiceAmount: '₹70,000',
    paidAmount: '₹70,000',
    paymentStatus: 'Paid',
    date: '15 March',
  },
  {
    id: 4,
    advisorName: 'Vikas',
    invoiceAmount: '₹70,000',
    paidAmount: '₹70,000',
    paymentStatus: 'Paid',
    date: '15 March',
  },
];
const AdvisorRenumeration = () => {
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [advisorRows, setAdvisorRows] = useState(initialAdvisorRows);
  const [paymentRows, setPaymentRows] = useState(initialPaymentRows);
  const [selectedDate, setSelectedDate] = useState('1 Mar - 1 Apr');
  const handleSearch = (term) => {
    setSearchTerm(term);
    if (activeTab === 0) {
      const filteredRows = initialAdvisorRows.filter(row =>
        row.advisorName.toLowerCase().includes(term.toLowerCase())
      );
      setAdvisorRows(filteredRows);
    } else if (activeTab === 2) {
      const filteredRows = initialPaymentRows.filter(row =>
        row.advisorName.toLowerCase().includes(term.toLowerCase())
      );
      setPaymentRows(filteredRows);
    }
  };

  const advisorColumns = [
    {
      field: 'advisorName',
      headerName: 'Advisor Name',
      width: '197.2px',
    },
    {
      field: 'totalEarnings',
      headerName: 'Total Earnings',
      width: '197.2px',
    },
    {
      field: 'receivedEarnings',
      headerName: 'Received Earnings',
      width: '197.2px',
    },
    {
      field: 'pendingEarnings',
      headerName: 'Pending Earnings',
      width: '197.2px',

    },
    {
      field: 'lastPaymentDate',
      headerName: 'Last Payment Date',
      width: '197.2px',

    },
    {
      field: 'action',
      headerName: 'Action',
      width: '150px',
      renderCell: () => (
        <CustomButton
          label="View"
          startIcon={<Eye className="w-4 h-4" />}
          variant="text"
          size="sm"
          onClick={() => { navigate("/advisordetail") }}
        />
      ),
    },
  ];
  const InvoiceColumns = [
    {
      field: 'advisorName',
      headerName: 'Advisor Name',
      width: '246.5px',
    },
    {
      field: 'noOfLeads',
      headerName: 'No. Of Leads',
      width: '246.5px',
    },
    {
      field: 'invoiceAmount',
      headerName: 'Invoice Amount',
      width: '246.5px',
    },
    {
      field: 'invoiceStatus',
      headerName: 'Invoice Status',
      width: '246.5px',
      renderCell: (row) => (
        <CustomChip
          label={row.invoiceStatus}
          variant={
            row.invoiceStatus === 'Approved'
              ? 'success'
              : row.invoiceStatus === 'Pending'
                ? 'warning'
                : 'error'
          }
          size="sm"
        />
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      width: '150px',
      renderCell: () => (
        <CustomButton
          label="View"
          startIcon={<Eye className="w-4 h-4" />}
          variant="text"
          size="sm"
          onClick={() => { navigate("/advisordetail") }}
        />
      ),
    },
  ];
  const paymentColumns = [
    {
      field: 'advisorName',
      headerName: 'Advisor Name',
      width: '200px',
    },
    {
      field: 'invoiceAmount',
      headerName: 'Invoice Amount',
      width: '200px',
    },
    {
      field: 'paidAmount',
      headerName: 'Paid Amount',
      width: '200px',
    },
    {
      field: 'paymentStatus',
      headerName: 'Payment Status',
      width: '200px',
      renderCell: (row) => (
        <CustomChip
          label={row.paymentStatus}
          variant={
            row.paymentStatus === 'Paid'
              ? 'success'
              : row.paymentStatus === 'Partially Paid'
                ? 'warning'
                : 'error'
          }
          size="lg"
        />
      ),
    },
    {
      field: 'date',
      headerName: 'Date',
      width: '150px',
    },
    {
      field: 'action',
      headerName: 'Action',
      width: '150px',
      renderCell: () => (
        <CustomButton
          label="View"
          variant="text"
          size="sm"
          startIcon={<Eye className="w-4 h-4" />}
          onClick={() => { navigate("/advisordetail") }}
        />
      ),
    },
  ];
  const AdvisorsContent = (
    <div className="">
      <div className="flex justify-between items-center mb-6">
        <div className="w-80 bg-white">
          <CustomSearch
            placeholder="Search advisors..."
            onChange={handleSearch}
            className="w-full"
          />
        </div>

      </div>
      <CustomDataGrid
        columns={advisorColumns}
        rows={advisorRows}
        keyId="id"
        perPageSize={10}
        showPagination={false}
      />
    </div>
  );
  const InvoiceContent = (
    <div className="">
      <div className="flex justify-between items-center mb-6">
        <div className="w-80 bg-white">
          <CustomSearch
            placeholder="Search advisors..."
            onChange={handleSearch}
            className="w-full"
          />
        </div>
        <div className="flex items-center gap-4">
          <CustomButton
            label="Download Excel"
            variant="contained"
            size="md"
            startIcon={<Download className="w-4 h-4" />}
            onClick={() => setOpen(true)}
          />
          <div className="flex items-center gap-4">
            
            <Formik initialValues={{ date: "" }} onSubmit={console.log}>
              {() => (
                <Form>
                  <CustomDatePicker name="date" label="" placeholder='Select Dates' />
               
                </Form>
              )}
            </Formik>

        
        </div>
        </div>
      </div>
      <CustomDataGrid
        columns={InvoiceColumns}
        rows={invoiceRows}
        keyId="id"
        perPageSize={10}
        showPagination={false}
      />
    </div>
  );
  const PaymentsContent = (
    <div className="">
      <div className="flex justify-between items-center mb-6">
        <div className="w-80 bg-white">
          <CustomSearch
            placeholder="Search advisors..."
            onChange={handleSearch}
            className="w-full"
          />
        </div>
        <div className="flex items-center gap-4">
          <CustomButton
            label="Upload MIS"
            variant="contained"
            size="md"
            startIcon={<Upload className="w-4 h-4" />}
            onClick={() => { setOpen1(true) }}
          />
          <div className="flex items-center gap-4">
            
            <Formik initialValues={{ date: "" }} onSubmit={console.log}>
              {() => (
                <Form>
                  <CustomDatePicker name="date" label="" placeholder='Select Dates' />
               
                </Form>
              )}
            </Formik>

        
        </div>
        </div>
      </div>
      <CustomDataGrid
        columns={paymentColumns}
        rows={paymentRows}
        keyId="id"
        perPageSize={10}
        showPagination={false}
      />
    </div>
  );
  const tabList = [
    {
      title: 'Advisors',
      component: AdvisorsContent,
    },
    {
      title: 'Invoices',
      component: InvoiceContent,
    },
    {
      title: 'Payments',
      component: PaymentsContent,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 ">

      <div className=" mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <button className="p-2 hover:bg-gray-100  border rounded-md" onClick={() => { navigate("/remuneration") }}>
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-2xl leading-7 font-semibold text-blue-900">
              Advisors Remunerations
            </h1>
          </div>
          <CustomChip
            label="Invoice Generated On 15 March 2025"
            variant="primary"
            size="lg"
          />
        </div>
        <div className="  ">
          <CustomTab
            tabList={tabList}
            tabIndex={activeTab}
          />
        </div>
      </div>
      <CustomDialog open={open1} setOpen={setOpen1} title='Upload MIS' titleClassName='px-6  py-8' className='!p-0 gap-0'>

        <div className=" py-4 text-center ">
          <div className='px-8'><DragAndDrop onFileUpload={(file) => setUploadedFile(file)} showPreview maxFiles={3} />
          </div>

          <div className="flex justify-end gap-3 p-4 mt-4 border-t">
            <button className="px-4 py-2 bg-gray-200 rounded-md" onClick={() => setOpen1(false)}>
              Cancel
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md" disabled={!uploadedFile}>
              Submit
            </button>
          </div>
        </div>
      </CustomDialog>
      <CustomDialog open={open} setOpen={setOpen} title="Download Notice" titleClassName="text-center">
        <div className=" w-[400px] text-center">
          <p className="text-gray-600 text-left border-b">
            You can download this only once. Any status changes after this download will be
            reflected in next month's invoices.
          </p>
          <div className="flex justify-between gap-3 mt-4  ">
            <button
              className="py-2 px-4 bg-gray-200 font-semibold text-base w-[170px] rounded-md"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>

            <button className="py-2 px-4 bg-[#007BFF] w-[170px] font-semibold text-base text-white rounded-md">
              Continue
            </button>
          </div>
        </div>
      </CustomDialog>
    </div>
  );
}

export default AdvisorRenumeration















